import { createContext } from 'react';

// ----------------------------------------------------------------------

export type SelectedTenantContextValue = {
  /** 可切换的租户成员列表 */
  tenants: MyApi.OutputTenantMembershipDto[];
  /** 当前会话租户主键（tenants.id） */
  tenantId: string;
  /** 当前选中的成员关系 */
  membership?: MyApi.OutputTenantMembershipDto;
  loading: boolean;
  switching: boolean;
  setTenantId: (tenantId: string) => void;
  /** 切换租户并刷新 Token */
  switchTenant: (tenantId: string) => Promise<void>;
};

export const SelectedTenantContext = createContext<SelectedTenantContextValue | undefined>(undefined);
